module.exports = __webpack_public_path__ + "img/35.b8d420f7.jpeg";